import SubPageLayout from '../helpers/SubPageLayout';


const ProductionPlanningView = () => {
  

  return (
    <SubPageLayout title="Production Planning">
      
    </SubPageLayout>
  );
};

export default ProductionPlanningView;